module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/logo3.a04beb9e.png";